import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.concat.js";
import "regenerator-runtime/runtime.js";
import form from '@/mixins/crud-form';
import utils from "@/utils";
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'BOX_DETAIL',
        create: 'BOX_CREATE',
        update: 'BOX_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      },
      userInfo: {}
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch('d2admin/db/get', {
                dbName: 'sys',
                path: 'user.info',
                defaultValue: {},
                user: true
              }, {
                root: true
              });

            case 2:
              _this.userInfo = _context.sent;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: {
    setting: function setting() {
      var _this2 = this;

      var h = this.$createElement;
      return [{
        prop: 'box_name',
        default: '',
        label: this.$t('box_name'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.form.model.box_name,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "box_name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'box_aspect_type',
        default: '',
        label: this.$t('box_aspect_type'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return _this2.userInfo.market_id == "17" || _this2.userInfo.market_id == "12" ? h("d2-dict-select", {
            "attrs": {
              "name": "box_aspect_type_two"
            },
            "model": {
              value: _this2.form.model.box_aspect_type,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "box_aspect_type", $$v);
              }
            }
          }) : h("d2-dict-select", {
            "attrs": {
              "name": "box_aspect_type",
              "button": true
            },
            "model": {
              value: _this2.form.model.box_aspect_type,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "box_aspect_type", $$v);
              }
            }
          });
        }
      }].concat(_toConsumableArray(this.mode === 'create' ? [{
        prop: 'box_aspect_num',
        default: '',
        label: this.$t('box_aspect_num'),
        col: {
          span: 8
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.form.model.box_aspect_num,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "box_aspect_num", $$v);
              }
            }
          });
        }
      }] : []), _toConsumableArray(this.mode === 'edit' ? [{
        prop: 'box_use_status',
        default: '',
        label: this.$t('box_use_status'),
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "box_use_status",
              "button": true
            },
            "model": {
              value: _this2.form.model.box_use_status,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "box_use_status", $$v);
              }
            }
          });
        }
      }] : []), [{
        prop: 'box_lock_address',
        default: '',
        label: this.$t('box_lock_address'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.form.model.box_lock_address,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "box_lock_address", $$v);
              }
            }
          });
        }
      }, {
        prop: 'device_number',
        default: this.device_number,
        label: this.$t('device_number'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.form.model.device_number,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "device_number", $$v);
              }
            }
          });
        }
      }]);
    },
    // [本页面特有] 父级字典项目的 id 强制转为数字
    device_number: function device_number() {
      return this.$route.query.device_number;
    }
  }
};